module.exports = __webpack_public_path__ + "static/media/apartment13.5d4617b0.jpg";